import { useContext } from "react"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"

/**
 * Les repères de mise en page du test d'entrée, partagés par le panneau et ses
 * composants.
 */

/**
 * En dessous de cette largeur, on cesse d'aligner le contenu sous le titre.
 *
 * Le retrait accroche le texte à la colonne des pictogrammes, ce qui range un
 * écran large. Sur un téléphone de 390 points il mange un dixième de la
 * largeur : l'aperçu rétrécit et les deux réponses ne tiennent plus côte à
 * côte.
 */
export const NARROW = 520

/** Ce retrait accroche le contenu d'une étape à la colonne des pictogrammes. */
export const INDENT = 41

/** Écran étroit — un téléphone, ou une fenêtre réduite. */
export const useNarrow = () => {
    const dimension = useContext(DimensionsContext)
    return (dimension?.width ?? 0) < NARROW
}

/**
 * Les deux valeurs de mise en page d'une étape, d'une seule lecture du
 * contexte — elles sortent du même seuil, et les recalculer séparément faisait
 * vivre la règle du retrait à deux endroits.
 */
export const useLayout = () => {
    const compact = useNarrow()
    return { compact, indent: compact ? 0 : INDENT }
}

/** Le retrait du contenu d'une étape, nul sur les écrans étroits. */
export const useIndent = () => useLayout().indent

/** Le système dit-il qu'il ne faut pas animer ? */
export const prefersReducedMotion = () =>
    IS_WEB &&
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
